/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Expand More Icon component.
 */
export const MaterialExpandMoreIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M20 8.86667L18.1333 7L12 13.1333L5.86667 7L4 8.86667L12 16.8667L20 8.86667Z' fill={iconColor} />
    </svg>
  );
};

export default MaterialExpandMoreIcon;
